import React, { lazy } from 'react'
import { Navigate } from 'react-router'
import type { RouteObject } from 'react-router'
import { getAuthToken } from '@core/lib/cache'

const LoginContainer = lazy(() => import('./containers/LoginContainer'))
const SignUpContainer = lazy(() => import('./containers/SignUpContainer'))
const VerifyCodeContainer = lazy(
    () => import('./containers/VerifyCodeContainer')
)
const ForgotPasswordContainer = lazy(
    () => import('./containers/ForgotPasswordContainer')
)

const token = getAuthToken()

const routes: RouteObject[] = [
    {
        path: '/',
        element: <Navigate replace to={token ? '/home' : '/login'} />
    },
    {
        path: '/login',
        element: <LoginContainer />
    },
    {
        path: '/forgot-password',
        element: <ForgotPasswordContainer />
    },
    {
        path: '/sign-up',
        element: <SignUpContainer />
    },
    {
        path: '/verify-code',
        element: <VerifyCodeContainer />
    }
]

export default routes
